import { render, staticRenderFns } from "./SimpleInfoModal.vue?vue&type=template&id=751797c4"
import script from "./SimpleInfoModal.vue?vue&type=script&lang=js"
export * from "./SimpleInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports